import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 47869 58086"
    {...props}
  >
    <path
      d="M11382 6908v19701L33727 3297c1072-1125 1988-1949 2734-2486 758-536 1765-811 3008-811 1636 0 2970 484 3978 1439 1007 955 1504 2120 1504 3506 0 1662-850 3310-2564 4946L28559 22986l15934 22841c1125 1584 1976 2970 2538 4161 563 1177 838 2341 838 3466 0 1243-497 2329-1479 3258-981 916-2316 1374-4003 1374-1583 0-2878-341-3873-1021-994-667-1831-1570-2525-2695-692-1125-1307-2146-1844-3061L20696 30613l-9314 8922v11617c0 2354-536 4094-1609 5233-1073 1138-2459 1701-4134 1701-981 0-1910-262-2800-772-903-510-1582-1191-2067-2068-366-706-576-1543-654-2485-79-942-118-2315-118-4094V6894c0-2302 511-4015 1518-5167C2525 576 3899 0 5639 0c1700 0 3088 563 4147 1701 1060 1138 1596 2878 1596 5207z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
